import { useMantineColorScheme, ActionIcon, Group, Button } from '@mantine/core';
import { Sun, MoonStars } from 'tabler-icons-react'
export function ActionToggle() {
  const { colorScheme, toggleColorScheme } = useMantineColorScheme();


const toggleStorage = () => localStorage.setItem('ColorScheme' ,(colorScheme === 'dark' ? 'light' : 'dark'));


  return (
      <Button
        onClick={() => {toggleColorScheme()
            toggleStorage();
        }}
        radius="lg"
        variant='default'
        style={{border:0, display: "flex", height: "50px", width:"50px",justifyContent: "center", alignItems: "center" }}
    
      >
        {colorScheme === 'dark' ? <Sun color='yellow' /> : <MoonStars size={20}/>}
      </Button>
  );
}

